import { IconButton, AppBar, Toolbar, Table, TableHead, TableBody, TableRow, TableCell, Checkbox, Button,  Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Select,
    MenuItem,} from "@material-ui/core";
import * as React from "react";
import { Theme } from "@material-ui/core/styles";
import { observable, action, toJS } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { Route, RouteComponentProps, Switch } from "react-router";
import { config } from "src/config";
import { observer } from "mobx-react";
import { history } from "src/history.js";
import { permissionsStore } from '.';

const styles = ({ typography }: Theme) =>
    createStyles({
        root: {
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: 'hidden'
        },
        table: {
            height: "100%",
            flex: 1,
            fontFamily: "inherit",
        },
        tableIconCell: {
            display: "flex",
            justifyContent: "center",
        },
        tableIconHeader: {
            marginRight: "1rem",
        },
        tableDefaultCell: {
            marginRight: ".25rem",
            marginLeft: ".25rem",
            display: "flex",
            alignItems: "center",
            fontFamily: typography.fontFamily,
        },
        tableDefaultHeader: {
            fontFamily: typography.fontFamily,
        },
        content: {
            flex: 1,
            display: "flex",
        },
        subheaderRow: {
            backgroundColor: '#cddadb',
        }
    });

@observer
class Permissions extends React.Component<any> {

    constructor(props: any) {
        super(props);
    }
    // E-048
    public state = {
        current_tab: 0,
        deleteDialogOpen: false,
        logOutTime: [],
        logoutTimeonChange: "",
      };

      public allAviableTimes = [  // E-048
        { key: 5, value: "5 min" },
        { key: 10, value: "10 min" },
        { key: 15, value: "15 min" },
        { key: 30, value: "30 min" },
        { key: 45, value: "45 min" },
      ];
    



    public componentDidMount = async () => {
        await permissionsStore.getAllPermissionList();
        await permissionsStore.getAllPortalRoles();
        const rolesArray = permissionsStore.allPortalRoles.filter(roles => roles.portal_role_id !== 1)  // E-048
        this.setState({ logOutTime:rolesArray })  // E-048
    }

    public handleChange = (permission_id: number, role_id: number, active: number) => {
        permissionsStore.updateRolePermission(permission_id, role_id, active);
    }

    public submit = () => {
        return permissionsStore.savePermissions()
    }
       //E-048.2  
       public saveAutoLogOutTimeSetting = async() => {
        await permissionsStore.AutoLogFuction();
        this.setState({ deleteDialogOpen: false })
      };

        //E-048.2
        public handleAutoLogOutTimeChange = (test: string,id:number) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
            this.state.logOutTime.map((time:any,index)=>{
                if(time.portal_role_id==id){
                    let newObject:any= this.state.logOutTime
                    newObject[index].Log_Out_Time = e.target.value
                    this.setState({logOutTime: newObject})
                }
            })
          };
         //E-048.2
          public getDeleteDialog = (active: boolean) => {
            return (
              <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                // tslint:disable-next-line: jsx-no-lambda
                onBackdropClick={() => this.setState({ deleteDialogOpen: false })}
              >
                <DialogTitle>Auto Log Out Time</DialogTitle>
                {/* <DialogTitle>
                      Confirm Enable{" "}
                      {usersAdminStore.current_user.FirstName +
                        " " +
                        usersAdminStore.current_user.LastName}
                      ?
                    </DialogTitle> */}
                <DialogContent />
                <div style={{maxWidth:"98%",overflowX:"scroll" , marginBottom:"2rem", paddingBlock:"1rem"}}>
                  <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Description</TableCell>
                      {(permissionsStore.allPortalRoles || [])
                        .filter((role: any) => role.portal_role_id !== 1)
                        .map(role_info => {
                          return (
                            <TableCell key={role_info.portal_role_id}>
                              {role_info.PortalRoleName}
                            </TableCell>
                          );
                        })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>Auto Log Out Time</TableCell>
                      {this.state.logOutTime
                        .map((role_info:any, index) => {
                          return (
                            <TableCell key={role_info.portal_role_id}>
                              <Select
                                // inputProps={{ name: "role_id", id: "role_id" }}
                                value={role_info.Log_Out_Time}
                                // classes={{ root: classes.roleSelect }}
                                // tslint:disable-next-line: jsx-no-lambda
                                onChange={this.handleAutoLogOutTimeChange('',role_info.portal_role_id)}
                              >
                                {this.allAviableTimes.map(
                                  (role: any) => {
                                    return (
                                      <MenuItem value={role.key}>
                                        {role.value}
                                      </MenuItem>
                                    );
                                  }
                                )}
                              </Select>
                              {/* {role_info.Log_Out_Time} */}
                            </TableCell>
                          );
                        })}
                    </TableRow>
                  </TableBody>
                </Table>
                </div>
                
                <DialogActions>
                  <Button
                    variant="contained"
                    classes={{ root: this.props.classes.submitButton }}
                    // tslint:disable-next-line: jsx-no-lambda
                    onClick={() => this.saveAutoLogOutTimeSetting()}
                    color="primary"
                  >
                    Submit
                  </Button>
        
                  <Button
                    variant="contained"
                    classes={{ root: this.props.classes.submitButton }}   //E-048.2
                    // tslint:disable-next-line: jsx-no-lambda
                    onClick={() => this.setState({ deleteDialogOpen: false })}
                    color="primary"
                    autoFocus={true}
                  >
                    Cancel
                  </Button>
                </DialogActions>
              </Dialog>
            );
          };

// chnage the table body E-048
    public getPermissionsContent = () => {
        const { classes } = this.props
        let current_component_name = ''
        return (
          <div>
            <Table>
            <TableHead style={{ position: "sticky", top: "35px", backgroundColor: "rgb(249 246 246)", zIndex: 1 }}>  {/* C-018 */}
                    <TableRow>
                        <TableCell>Description</TableCell>
                        {permissionsStore.allPortalRoles.filter((role: any) => role.portal_role_id !== 1).map((role_info) => {
                                return (
                                    <TableCell key={role_info.portal_role_id}>{role_info.PortalRoleName}</TableCell>
                                )
                        })
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
          {permissionsStore.allPermissionList
            .filter(
              permission_info =>
                permission_info.PermissionType !== "navbar" &&
                permission_info.PermissionCategory !== "utils"
            )
            .map(permission_info => {
              const table_rows:any = [];
              if (
                permission_info.PermissionCategory !== current_component_name
              ) {
                current_component_name = permission_info.PermissionCategory;

                table_rows.push(
                  <TableRow
                    key={current_component_name}
                    className={classes.subheaderRow}
                  >
                    {/* C-018 */}
                    <TableCell colSpan={8}> 
                      {current_component_name.charAt(0).toUpperCase() +
                        current_component_name.slice(1) +
                        " Permissions"}

                      {current_component_name.charAt(0).toUpperCase() +
                        current_component_name.slice(1) ===
                        "User" && (
                        <Button
                        //   classes={{ root: classes.submitButton }}
                          variant={'contained'}
                        //   color=''
                          onClick={() =>
                            this.setState({ deleteDialogOpen: true })  //E-048.2
                          }
                        >
                            
                          Time
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                );
              }

              table_rows.push(
                <TableRow key={permission_info.permission_id}>
                  <TableCell>{permission_info.PermissionDescription}</TableCell>
                  {permission_info.ActiveRoleList.filter(
                    (role: any) => role.role_id !== 1
                  ).map(permission_role_info => (
                    <TableCell key={permission_role_info.role_id}>
                      <Checkbox
                        checked={Boolean(permission_role_info.Active)}
                        // tslint:disable-next-line: jsx-no-lambda
                        onChange={event =>
                          this.handleChange(
                            permission_info.permission_id,
                            permission_role_info.role_id,
                            event.target.checked ? 1 : 0
                          )
                        }
                        disabled = {!permissionsStore.checkPermissionByCategoryAndType('permission', 'update')}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              );

              return table_rows;
            })}
        </TableBody>
            </Table>
      </div>
    )};

    public render() {
        const { classes } = this.props; 
        const deleteDialog = this.getDeleteDialog(this.state.deleteDialogOpen); // E-048

        if (!permissionsStore.allPermissionList || !permissionsStore.allPortalRoles) {
            return (<div>loading</div>)
        }


        return (
            <div>
                    {deleteDialog}
        {/* C-018 */}
        <div className="cstmSubmitBtn" style={{ position: "sticky", top: "0", marginBottom: "20px", backgroundColor: "#ffffff", zIndex: 1, }}>  
                <Button
                    classes={{ root: classes.submitButton }}
                    onClick={this.submit}
                    variant='contained'
                >
                    Submit
                </Button>
                </div>
                {this.getPermissionsContent()}
            </div>
        );
    }

}

export default withStyles(styles, { withTheme: true })(Permissions);


// WEBPACK FOOTER //
// ./src/modules/admin/modules/Permissions/Permissions.tsx